import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const ApplicationPage: React.FC = () => {
  const intl = useIntl();

  return (
    <Wrapper>
      <Header>
        <h1>Søknad om påtegning</h1>
      </Header>
      <Content>
        <div>TODO: Content</div>
      </Content>
    </Wrapper>
  );
};

export default ApplicationPage;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;
